/* Ampd: FAQs page
   1. Search across every question and answer. Matches are highlighted, the count is announced,
      empty categories hide (in the page and the jump bar), and three or fewer results open.
   2. "Open all answers" toggle.
   3. Deep links: #faq-<question> opens and highlights that answer; works for links from other pages
      and the "Most asked" list.
   4. Category jump bar pins under the header like ampd-anchor-nav and highlights the current topic. */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
  var reEsc = function (s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); };

  function headerBottom() {
    var h = document.querySelector('.cc-header') || document.querySelector('.shopify-section-group-header-group');
    if (h) {
      var cs = getComputedStyle(h);
      if (cs.position === 'sticky' || cs.position === 'fixed') return Math.max(0, h.getBoundingClientRect().bottom);
    }
    return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
  }

  function init(root) {
    if (!root || root.dataset.ampdReady) return;
    root.dataset.ampdReady = '1';

    var items = $$('details.ampd-support-faqs__item', root);
    var groups = $$('[data-ampd-faqs-group]', root);
    var input = $('[data-ampd-faqs-search]', root);
    var countEl = $('[data-ampd-faqs-count]', root);
    var empty = $('[data-ampd-faqs-empty]', root);
    var expandBtn = $('[data-ampd-faqs-expand]', root);
    var navLinks = $$('[data-ampd-faqs-nav]', root);
    var total = items.length;

    // Keep each question's original text so highlights can be added and removed cleanly
    items.forEach(function (d) {
      var q = $('[data-ampd-faq-q]', d);
      if (q) q.setAttribute('data-text', q.textContent);
      d._hay = d.textContent.toLowerCase();
    });

    function defaultCount() {
      return total + ' questions across ' + groups.length + ' topics';
    }

    function setQuestionText(d, words) {
      var q = $('[data-ampd-faq-q]', d);
      if (!q) return;
      var text = q.getAttribute('data-text');
      if (!words.length) { q.textContent = text; return; }
      var re = new RegExp('(' + words.map(reEsc).join('|') + ')', 'gi');
      q.innerHTML = esc(text).replace(re, '<mark>$1</mark>');
    }

    function syncGroups() {
      groups.forEach(function (g) {
        var any = $$('details.ampd-support-faqs__item', g).some(function (d) { return !d.hidden; });
        g.hidden = !any;
        var key = g.getAttribute('data-ampd-faqs-group');
        navLinks.forEach(function (a) { if (a.getAttribute('data-ampd-faqs-nav') === key) a.parentElement.hidden = !any; });
      });
    }

    function search(raw) {
      var words = raw.toLowerCase().split(/\s+/).filter(Boolean).map(function (w) {
        return w.length > 3 && /[^s]s$/.test(w) ? w.slice(0, -1) : w;
      });
      var hits = [];
      items.forEach(function (d) {
        var ok = words.every(function (w) { return d._hay.indexOf(w) > -1; });
        d.hidden = !ok;
        setQuestionText(d, ok ? words : []);
        if (ok) hits.push(d);
      });
      syncGroups();
      if (!words.length) {
        countEl.textContent = defaultCount();
        if (empty) empty.hidden = true;
        return;
      }
      countEl.textContent = hits.length
        ? hits.length + (hits.length === 1 ? ' answer' : ' answers') + ' for “' + raw.trim() + '”'
        : 'No answers for “' + raw.trim() + '”';
      if (empty) {
        empty.hidden = hits.length > 0;
        var term = $('[data-ampd-faqs-term]', empty); if (term) term.textContent = raw.trim();
      }
      if (hits.length && hits.length <= 3) hits.forEach(function (d) { d.open = true; });
      syncExpand();
    }

    var timer = null;
    if (input) {
      input.addEventListener('input', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { search(input.value); }, 120);
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          var first = items.filter(function (d) { return !d.hidden; })[0];
          if (first) reveal(first, false);
        }
      });
    }
    $$('[data-ampd-faqs-clear]', root).forEach(function (b) {
      b.addEventListener('click', function () { if (input) { input.value = ''; input.focus(); } search(''); });
    });

    /* ---------- Open all ---------- */
    function syncExpand() {
      if (!expandBtn) return;
      var visible = items.filter(function (d) { return !d.hidden; });
      var allOpen = visible.length && visible.every(function (d) { return d.open; });
      expandBtn.textContent = allOpen ? 'Close all answers' : 'Open all answers';
      expandBtn.setAttribute('aria-pressed', allOpen ? 'true' : 'false');
    }
    if (expandBtn) expandBtn.addEventListener('click', function () {
      var visible = items.filter(function (d) { return !d.hidden; });
      var open = !visible.every(function (d) { return d.open; });
      visible.forEach(function (d) { d.open = open; });
      syncExpand();
    });
    items.forEach(function (d) { d.addEventListener('toggle', syncExpand); });

    /* ---------- Deep links ---------- */
    function reveal(d, flash) {
      if (d.hidden && input) { input.value = ''; search(''); }
      d.open = true;
      if (flash !== false) {
        d.classList.add('is-flash');
        setTimeout(function () { d.classList.remove('is-flash'); }, 2400);
      }
      d.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      var s = $('summary', d); if (s) s.focus({ preventScroll: true });
    }
    function fromHash() {
      var id = decodeURIComponent((location.hash || '').slice(1));
      if (!id || id.indexOf('faq-') !== 0) return;
      var el = document.getElementById(id);
      if (!el) return;
      if (el.matches('details')) setTimeout(function () { reveal(el); }, 60);
      else if (el.hidden && input) { input.value = ''; search(''); el.scrollIntoView(); }
    }
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-ampd-faqs-open]');
      if (!a) return;
      var el = document.getElementById(a.getAttribute('href').slice(1));
      if (!el) return;
      e.preventDefault();
      if (history.replaceState) history.replaceState(null, '', a.getAttribute('href'));
      reveal(el);
    });
    window.addEventListener('hashchange', fromHash);

    /* ---------- Jump bar ---------- */
    var shell = $('[data-ampd-faqs-jump-shell]', root);
    if (shell) {
      var bar = $('[data-ampd-faqs-jump]', shell);
      var spacer = $('[data-ampd-faqs-jump-spacer]', shell);
      var list = $('ul', bar);
      var pinned = false, h = bar.offsetHeight, active = null;
      var sync = function () {
        if (!pinned) h = bar.offsetHeight;
        var top = headerBottom();
        document.documentElement.style.setProperty('--ampd-faqs-offset', (top + h) + 'px');
        if (spacer.getBoundingClientRect().top <= top) {
          if (!pinned) { pinned = true; spacer.style.height = h + 'px'; bar.classList.add('is-pinned'); }
          if (bar.style.top !== top + 'px') bar.style.top = top + 'px';
        } else if (pinned) {
          pinned = false; bar.classList.remove('is-pinned'); bar.style.top = ''; spacer.style.height = '0px';
        }
        var line = top + h + 40, cur = null;
        groups.forEach(function (g) {
          if (!g.hidden && g.getBoundingClientRect().top <= line) {
            cur = navLinks.filter(function (a) { return a.getAttribute('data-ampd-faqs-nav') === g.getAttribute('data-ampd-faqs-group'); })[0] || cur;
          }
        });
        if (cur !== active) {
          active = cur;
          navLinks.forEach(function (l) {
            var on = l === cur;
            l.classList.toggle('is-active', on);
            if (on) l.setAttribute('aria-current', 'location'); else l.removeAttribute('aria-current');
          });
          if (cur && list.scrollWidth > list.clientWidth) {
            var li = cur.parentElement;
            list.scrollTo({ left: li.offsetLeft - (list.clientWidth - li.offsetWidth) / 2, behavior: reduceMotion ? 'auto' : 'smooth' });
          }
        }
      };
      var ticking = false;
      var onScroll = function () { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; sync(); }); };
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      window.addEventListener('load', sync);
      sync();
    }

    countEl.textContent = defaultCount();
    root.classList.add('is-ready');
    syncExpand();
    fromHash();
  }

  function initAll(scope) { $$('[data-ampd-faqs-page]', scope).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
